import moment from 'moment'
import { i18n } from '@/i18n'

export function formatLastConnection (value) {
  return value ? moment(value).format('DD-MM-yyyy HH:mm') : i18n.t('dashboard.connected_users_no_last_connection')
}

export function sanitizePriceDecimal2Comma (value, padDecimals = false) {
  value = String(value)
  let cleaned = value.replace('.', ',')
  cleaned = cleaned.replace(/[^0-9,]/g, '')
  const firstDot = cleaned.indexOf(',')
  if (firstDot !== -1) {
    cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/,/g, '')
  }
  const parts = cleaned.split(',')
  if (parts[1] !== undefined && parts[1].length > 2) {
    cleaned = parts[0] + ',' + parts[1].slice(0, 2)
  }
  if (padDecimals) {
    const decimalParts = cleaned.split(',')
    const decimals = decimalParts[1] !== undefined ? decimalParts[1] : ''
    cleaned = decimalParts[0] + ',' + decimals.padEnd(2, '0')
  }
  if (/^0+,00$/.test(cleaned)) return '0'
  return cleaned
}

export function sanitizePriceDecimal2Dot (value) {
  value = String(value)
  let cleaned = value.replace(',', '.')
  cleaned = cleaned.replace(/[^0-9.]/g, '')
  const firstDot = cleaned.indexOf('.')
  if (firstDot !== -1) {
    cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '')
  }
  const parts = cleaned.split('.')
  if (parts[1] !== undefined && parts[1].length > 2) {
    cleaned = parts[0] + '.' + parts[1].slice(0, 2)
  }
  if (/^0+\.00$/.test(cleaned)) return '0'
  return cleaned
}
